<template>
  <div class="person-list">
    <div class="person-list-form">
      <el-form ref="form" label-width="130px" size="small" :model="form">
        <el-row>
          <el-col :span="8">
            <el-form-item label="合同编号" prop="enterpriseName">
              <el-input placeholder="请输入合同编号" v-model="form.enterpriseName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="员工姓名" prop="enterpriseName">
              <el-input placeholder="请输入员工姓名" v-model="form.enterpriseName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="合同签约状态" prop="invoiceApplyStatus">
              <el-select v-model="form.invoiceApplyStatus">
                <el-option v-for="(item, index) in applyStatusAll" :key="index" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="合同签署日期" prop="time">
              <el-date-picker
                v-model="form.comfirmInvoiceTime"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item style="margin-bottom: 0px; text-align: right;">
              <el-button @click="resetForm()">重置</el-button>
              <el-button type="primary" @click="submitForm()">查询</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="person-list-opea">
      <el-button size="small" @click="exportInfo()">批量下载合同</el-button>
    </div>
    <el-table>
      <el-table-column prop="invoiceApplyNo" label="合同编号" width="150"> </el-table-column>
      <el-table-column prop="invoiceApplyStatus" label="合同名称"> </el-table-column>
      <el-table-column prop="applyTime" label="甲方名称"> </el-table-column>
      <el-table-column prop="comfirmInvoiceTime" label="服务费率" width="160"></el-table-column>
      <el-table-column prop="comfirmInvoiceTime" label="服务事项" width="160"></el-table-column>
      <el-table-column prop="comfirmInvoiceTime" label="发票类目" width="160"></el-table-column>
      <el-table-column prop="comfirmInvoiceTime" label="合同期起" width="160"></el-table-column>
      <el-table-column prop="comfirmInvoiceTime" label="合同期止" width="160"></el-table-column>
      <el-table-column prop="comfirmInvoiceTime" label="合同执行状态" width="160"></el-table-column>
      <el-table-column fixed="right" label="操作" width="80">
        <template>
          <el-button type="text" size="small">下载</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { applyStatusAll } from '@/utils/enum';

export default {
  name: 'invoiceApply',
  data() {
    return {
      applyStatusAll,
      form: {
        enterpriseName: '',
        invoiceApplyStatus: 0,
        time: '',
      },
      data: [],
    };
  },
  methods: {
    submitForm() {},
    resetForm() {
      this.$refs.form.resetFields();
    },
    setAmount() {
      this.$refs.invoceRef.show();
    },
    exportInfo() {},
  },
};
</script>

<style lang="less" scoped>
.person-list {
  .person-list-form {
    border: 1px solid #ebeef5;
    padding: 16px;
    .form-title {
      font-size: 16px;
      font-weight: 700;
      color: #050505;
      margin-bottom: 20px;
      display: block;
    }
  }
  .person-list-opea {
    text-align: right;
    padding: 16px 0px;
  }
  /deep/ .el-date-editor--daterange.el-input__inner {
    width: 100%;
  }
  /deep/ .el-select {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/contractManage/personList.vue